document.addEventListener('DOMContentLoaded', function () {
  quantityDropDown();
  setQuantityValue();
  function quantityDropDown() {
    const quantitySelector = document.querySelector('#connected-quantity-selector');
    quantitySelector.addEventListener('change', setQuantityValue);
  }

  function setQuantityValue(e) {
    const quantity = document.querySelector('.quantity__input[name="quantity"]');
    const plusButton = document.querySelector('.quantity__button[name="plus"]');
    const minusButton = document.querySelector('.quantity__button[name="minus"]');
    const clicks = parseInt(e.target.value) - parseInt(quantity.value);
    console.log(quantity, plusButton, minusButton, clicks);
    if (clicks > 0) {
      for (let i = 0; i < clicks; i++) {
        plusButton.click();
        console.log('plus button clicked');
      }
    } else {
      for (let i = 0; i > clicks; i--) {
        minusButton.click();
        console.log('minus button clicked');
      }
    }
    updatePriceDisplay(parseInt(e.target.value))
  }
  function updatePriceDisplay(quantity) {
    const livePrice = document.querySelector(".live-price-display")
    const price = parseFloat(livePrice.getAttribute('data-price'))
    const currency = livePrice.getAttribute('data-currency')
    livePrice.innerHTML = `${(price*quantity).toFixed(2)} ${currency}`
  }
});
